(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairImportDataModalController', VirtualFairImportDataModalController)

    VirtualFairImportDataModalController.$inject = ['API_BASE', '$uibModalInstance', 'exhibitor', 'multiple', 'virtualFair', '$scope', 'FileUploader', 'toastr'];

    function VirtualFairImportDataModalController(API_BASE, $uibModalInstance, exhibitor, multiple, virtualFair, $scope, FileUploader, toastr) {
        var vm = this;

        vm.virtualFair = virtualFair
        vm.exhibitor   = exhibitor;
        vm.multiple    = multiple;

        vm.ok     = ok;
        vm.cancel = cancel;


        activate();


        function activate() {
            $scope.uploader = new FileUploader({
                url: API_BASE + '/virtualfairs/import-fair-data',
                withCredentials: false,
                method: 'POST',
                formData: [
                    {
                        'exhibitor_id': vm.exhibitor ? vm.exhibitor.user_id : "",
                        'virtual_fair_id': vm.virtualFair.id
                    }
                ],
                headers: {
                    'Authorization': 'Bearer ' +  localStorage.getItem('id_token')
                },
                removeAfterUpload: false,
                onCompleteItem: function(fileItem, response, status, headers) {
                    if (response.success)
                        toastr.success(response.message);
                    else if (response.message)
                        toastr.error(response.message);
                }
            });
        }


        function ok() {
            $uibModalInstance.close();
        }


        function cancel() {
            $uibModalInstance.close();
        }
    }

})();
